export const DEFAULT_FILE_EXPORT_NAME: string = 'export.xlsx';
export const DEFAULT_FILE_EXPORT_LOG_NAME: string = 'errorLog.xlsx';
export const DEFAULT_FILE_EXPORT_SHEET_NAME: string = 'sheet';
